import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/security/auth.service';
import { CustomerService } from '../services/customer.service';

export const customerGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const customerService = inject(CustomerService);
  const router = inject(Router);

  if (authService.userIsCustomer() || customerService.customerActive()) {
    router.navigate(['/plataforma/home']);
    return false;
  }
  return true;
};
